import angular from 'angular';
import { curry, get, mapKeys, mapValues } from 'lodash';

// NOTE(ed): This directive is used to bring in one-way data from the redux store.
// In react-redux we would use selectors in mapStateToThis (mapStateToProps), which would have
// this component's props (ownProps.)
// Unfortunately, mapStateToThis from ngRedux does not provide the component's props.
// So the one-way dependencies from angular and ngRedux need to be combined together in $onChanges.
// To simplify this, @visnup and @ed wrote this directive to bring in redux dependencies as
// angular one-way bindings.
//
// In the below example, workOrders is one-way bound onto the component. redux-mapping values are
// relative to the state root.
// od-draft-inspection-form(
//   address='$ctrl.address'
//   flip='$ctrl.flip'
//   inspections='$ctrl.inspections'
//   inspection='$ctrl.inspection'
//   renovation-id='$ctrl.renovationId'
//   kind='{{kind}}'
//   redux-mapping='{ \
//     workOrders: "entities.workOrders", \
//   }'
//
// Debugging tips: inspect the element you have this directive on, get its scope, and check
// `reduxMapping` - angular.element($0).scope().reduxMapping

module.exports = angular.module('common.directives.redux-mapping', [
])
.directive('reduxMapping', function($compile, $ngRedux, $parse) {
  return {
    restrict: 'A',
    compile(iElement, iAttrs) {
      let cget = curry(get);
      let reduxMapping = $parse(iAttrs.reduxMapping)();
      mapKeys(reduxMapping, (_, key) => iAttrs.$set(key, `reduxMapping.${key}`));

      return scope => {
        scope.reduxMapping = {};
        let mapStateToThis = state => mapValues(reduxMapping, cget(state));
        let reduxUnsubscribe = $ngRedux.connect(mapStateToThis)(scope.reduxMapping);
        scope.$on("destroy", reduxUnsubscribe);
      };
    },
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/directives/redux-mapping.js
 **/